import { tokens } from './tokens';

// Paleta MUI derivada de los tokens. La consola es clara (type: 'light'); el
// acento primario de acción es Noche (botón oscuro de alto contraste, alineado
// con los CTA del brand book), y el secundario es el platino-acero.
export let palette: any = {
  type: 'light',
  primary: {
    // Botón/acción primaria: pastilla Noche con texto Marfil.
    main: tokens.text,
    contrastText: tokens.onAccent,
  },
  secondary: {
    main: tokens.accent,
    light: tokens.accentDim,
    contrastText: tokens.onAccent,
  },
  error: { main: tokens.error },
  warning: { main: tokens.pending },
  success: { main: tokens.success, contrastText: tokens.onAccent },
  info: { main: tokens.info },
  background: {
    default: tokens.bg,
    paper: tokens.card,
  },
  text: {
    primary: tokens.text,
    secondary: tokens.textDim,
    disabled: tokens.faint,
    hint: tokens.faint,
  },
  divider: tokens.line,
  action: {
    active: tokens.textDim,
    hover: tokens.card2,
    selected: tokens.card2,
    disabled: tokens.faint,
    disabledBackground: tokens.card2,
  },
};
